import { type IconProps } from './Icon.types';

const FooterHelpSupportIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  width,
  height,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 27 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9181 11.1437C15.8364 11.0795 14.6406 10.1597 14.1724 9.8107H14.0929C14.4473 10.1149 15.1595 10.8032 15.4013 11.0225C15.6785 11.2819 16.1433 11.8708 15.8662 12.0041L15.8419 12.0126C15.5239 12.0781 14.8481 11.9145 13.9736 11.5473C12.96 11.1219 11.7653 10.4675 11.4639 9.90159C11.4639 9.90159 14.529 7.81723 15.7701 6.89138C17.3601 5.70983 16.7329 4.7549 16.3818 4.48951C15.9479 4.15989 15.1739 4.03265 14.3789 4.00477H14.3524C13.5975 3.98587 12.8424 4.02312 12.0922 4.11626C11.8537 4.14171 9.5526 4.44225 9.34612 5.01666C9.32294 5.1027 9.3119 5.18147 9.52058 5.4808C9.87925 5.97357 10.3067 6.40098 10.787 6.74717H10.8522C10.3255 6.30485 10.0163 5.86859 9.94237 5.59592C9.93719 5.57485 9.9335 5.55338 9.93133 5.53169C9.93133 5.42626 9.95231 5.3075 10.1411 5.24206C10.3299 5.17662 11.2751 5.07604 12.2523 5.16087C13.246 5.24691 13.9339 5.41899 14.1669 5.6553C13.8676 5.84071 10.3907 8.14442 9.43335 8.86426C8.19007 9.7998 8.95857 10.9656 9.29202 11.2685C9.7127 11.6527 10.3244 11.9145 10.9218 12.0962H10.9284C11.4958 12.2579 12.0713 12.3833 12.652 12.4719C13.1809 12.5676 16.4569 13.199 16.7086 12.3313C16.8478 11.8466 16.108 11.2904 15.9214 11.1462"
      fill="currentColor"
    />
    <mask
      id="path-2-outside-1_5881_9436"
      maskUnits="userSpaceOnUse"
      x="0.75"
      y="0"
      width="24"
      height="22"
      fill="black"
    >
      <rect fill="white" x="0.75" width="24" height="22" />
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M23.75 2C23.75 1.44772 23.3023 1 22.75 1H2.75C2.19772 1 1.75 1.44772 1.75 2V15C1.75 15.5523 2.19772 16 2.75 16H5.75C6.30228 16 6.75 16.4477 6.75 17V19.5858C6.75 20.4767 7.82714 20.9229 8.45711 20.2929L12.4571 16.2929C12.6446 16.1054 12.899 16 13.1642 16H22.75C23.3023 16 23.75 15.5523 23.75 15V2Z"
      />
    </mask>
    <path
      d="M8.45711 20.2929L7.75 19.5858L8.45711 20.2929ZM2.75 2H22.75V0H2.75V2ZM2.75 15V2H0.75V15H2.75ZM5.75 15H2.75V17H5.75V15ZM7.75 19.5858V17H5.75V19.5858H7.75ZM11.75 15.5858L7.75 19.5858L9.16421 21L13.1642 17L11.75 15.5858ZM22.75 15H13.1642V17H22.75V15ZM22.75 2V15H24.75V2H22.75ZM22.75 17C23.8546 17 24.75 16.1046 24.75 15H22.75V17ZM13.1642 17V15C12.6338 15 12.1251 15.2107 11.75 15.5858L13.1642 17ZM5.75 19.5858C5.75 21.3676 7.90429 22.2599 9.16421 21L7.75 19.5858L7.75 19.5858H5.75ZM5.75 17H7.75C7.75 15.8954 6.85457 15 5.75 15V17ZM0.75 15C0.75 16.1046 1.64543 17 2.75 17V15H2.75H0.75ZM22.75 2H24.75C24.75 0.89543 23.8546 0 22.75 0V2ZM2.75 0C1.64543 0 0.75 0.89543 0.75 2H2.75V2V0Z"
      fill="currentColor"
      mask="url(#path-2-outside-1_5881_9436)"
    />
    <path
      d="M26.25 2.51367V17.5137C26.25 18.066 25.8023 18.5137 25.25 18.5137H24.75C24.1977 18.5137 23.75 18.9614 23.75 19.5137V20.591C23.75 21.4811 22.6744 21.9276 22.044 21.2992L19.5427 18.8055C19.3553 18.6186 19.1014 18.5137 18.8367 18.5137H13.75"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default FooterHelpSupportIcon;
